import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import { useAppSelector } from '../store/hooks'

type GtagFunction = (
  _command: 'event',
  _eventName: 'page_view',
  _params: Record<string, string>
) => void

type WindowWithGtag = Window & {
  gtag?: GtagFunction
}

const useAnalityc = () => {
  const location = useLocation()
  const businessName = useAppSelector(
    (state) => state.init.business?.name ?? ''
  )

  useEffect(() => {
    const currentWindow = window as WindowWithGtag

    if (!currentWindow.gtag) return

    currentWindow.gtag('event', 'page_view', {
      page_title: document.title,
      page_location: currentWindow.location.href,
      page_path: `${location.pathname}${location.search}${location.hash}`,
      business_name: businessName,
      enviroment: process.env.REACT_APP_ENV ?? 'unknown',
    })
  }, [businessName, location.pathname, location.search, location.hash])
}

export default useAnalityc
